import { Injectable } from '@angular/core';
import { CustomPageType } from '@core/const';
import { Page } from '@spartacus/core';
import { SmartEditService } from '@spartacus/smartedit';
import { filter, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CustomSmartEditService extends SmartEditService {
  private defaultPreviewArticleCode: string | undefined;

  processCmsPage(): void {
    this.baseSiteService
      .get()
      .pipe(
        filter((site: any) => Boolean(site)),
        take(1),
      )
      .subscribe((site) => {
        this.defaultPreviewArticleCode = site.defaultPreviewArticleCode;
      });

    super.processCmsPage();
  }

  /**
   * go to the default preview page
   */
  protected goToPreviewPage(cmsPage: Page): void {
    // only the first page is the smartedit preview page
    if (!this['isPreviewPage']) {
      this['isPreviewPage'] = true;

      if (cmsPage.type === CustomPageType.ArticlePage && this.defaultPreviewArticleCode) {
        this.routingService.go({
          cxRoute: 'articleDetail',
          params: { code: this.defaultPreviewArticleCode },
        });
      } else {
        super.goToPreviewPage(cmsPage);
      }
    }
  }
}
